import React, { Component } from 'react';

import ListItem from './styles';

class Form extends Component {
  onPress = () => {
    this.props.onPressItem(this.props.id);
  };

  render() {
    const { question, answer } = this.props.item;

    return (
      <ListItem
        onClick={this.onPress}
        onKeyDown={null}
        role="button"
        tabIndex="0"
        selected={this.props.selected}
      >
        <h2>{question}</h2>
        <p>{answer}</p>
      </ListItem>
    );
  }
}

export default Form;
